import React, { Fragment } from 'react';

import { Accordion, Text } from '@BICE_Vida/components';
import { Col, Row, Sanitize } from '@BICE_Vida/scp-components';

import { ModalFull, SvgImg } from '../../designSystem';

import styles from './AuthorizationModal.module.scss';

import componentsId from '../../utils/componentsId';
import { authorizationHoldingTexts } from '../../utils/generalTexts';

type AuthorizationModalT = {
  isOpen: boolean;
  onClose: () => void;
  mobile?: boolean;
};

function AuthorizationModal({ isOpen, onClose, mobile = false }: AuthorizationModalT) {
  const asideInformation = (
    <Fragment>
      {!mobile && <SvgImg name="iconModalHoldingCat" alt="icon cat modal holding" />}
      <Text className={styles.authorization_modal_info_aside_title}>
        {authorizationHoldingTexts.modal.title}
      </Text>
    </Fragment>
  );

  return (
    <ModalFull
      id={componentsId.holdingAuthorizationModal}
      isOpen={isOpen}
      onClose={onClose}
      asideChild={asideInformation}
    >
      <Row justify="center" className={styles.authorization_modal_info_body}>
        <Col sm={12} md={11} lg={8} xl={7}>
          <Text className={styles.authorization_modal_info_body_title}>
            {authorizationHoldingTexts.modal.subtitle}
          </Text>
          <Text className={styles.authorization_modal_info_body_description}>
            {authorizationHoldingTexts.modal.description}
          </Text>
          <div className={styles.authorization_modal_info_accordion}>
            {authorizationHoldingTexts.modal.accordions.map((data: any, key: number) => (
              <Accordion
                className={styles.container_accordion}
                headerText={data.title}
                key={`modal_accordion_info_${key}`}
              >
                <Sanitize className={styles.accordion_description} html={data.description} />
              </Accordion>
            ))}
          </div>
        </Col>
      </Row>
    </ModalFull>
  );
}

export default AuthorizationModal;
